// Recovered compiled webpack factory 83370. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { d: () => s });
  var n = i(24888);
  let s = {
    ...n.f,
    getAnimatableNone: (t) => {
      let e = n.f.parse(t);
      return n.f.createTransformer(t)(
        e.map((t) => ("number" == typeof t ? 0 : "object" == typeof t ? { ...t, alpha: 1 } : t)),
      );
    },
  };
}
